import { isLight, UI_CONTRAST_YIQ_THRESHOLD } from "../../../../../utils/Color";
import { cn } from "./cn";
import { CalendarIcon } from "./icons/CalendarIcon";

/*
 * Business Requirement:
 * OQG3-2598: foreground matches the Design palette pencil
 * (`getReadableTextColorForHex` → CSS "black" / "white").
 */
const DARK_ON_LIGHT = "black";
const LIGHT_ON_DARK = "white";

/* Shared "Add to Calendar" CTA so the default (hero) and the moved-to-bottom
 * placements render identically. 16px horizontal padding matches Figma; the
 * inner clip keeps long translations (Fr/it/pt-br/uk/ja) from overflowing
 * into that padding. Foreground follows isLight so white-on-pale-primary
 * palettes stay readable. */
const EventCalendarButton = ({
  primaryColor,
  label,
  onClick,
  textFont,
  className,
}) => {
  const foreground = isLight(
    primaryColor,
    [],
    UI_CONTRAST_YIQ_THRESHOLD,
  )
    ? DARK_ON_LIGHT
    : LIGHT_ON_DARK;

  return (
    <button
      type="button"
      onClick={onClick}
      style={{ backgroundColor: primaryColor }}
      className={cn(
        "flex h-14 w-full min-w-0 cursor-pointer items-center justify-center rounded px-4",
        className,
      )}
    >
      <span className="flex min-w-0 max-w-full items-center justify-center gap-2.5 overflow-hidden">
        <CalendarIcon size={24} color={foreground} className="shrink-0" />
        <span
          className="min-w-0 truncate text-xl leading-5.5 font-medium"
          style={{
            color: foreground,
            fontFamily: textFont || undefined,
          }}
        >
          {label}
        </span>
      </span>
    </button>
  );
};

export default EventCalendarButton;
